const DISPUTED = 4;
const ACKNOWLEDGED = 3;
const IN_PROGRESS = 2;
const NEW = 1;

export default {
  methods: {
    getTaskTitle(task) {
      return this.taskIconHelper(task).title;
    },
    getTaskStatuses(task) {
      return this.taskIconHelper(task).statuses.join(', ');
    },
    getTaskIconColor(task) {
      return this.taskIconHelper(task).color;
    },
    getTaskIcon(task) {
      return this.taskIconHelper(task).icon;
    },
    taskIsNew(task) {
      return task && task.is_open && task.last_task_status == NEW && !task.overdue;
    },
    getTaskCoachRead(task) {
      return task && task.last_reply_read_by_coach == 0 && task.is_open == 1;
    },
    taskIconHelper(task) {
      const defaultTask = {
        icon: "mdi-clipboard-outline",
        color: "grey lighten-2",
        title: "No Task Assigned",
        statuses: []
      };

      if (!task || task.new_task) return defaultTask;

      const statusMap = {
        closed: {
          condition: !task.is_open || (task.is_open && task.last_task_status === ACKNOWLEDGED),
          icon: "mdi-clipboard-text-off-outline",
          color: "grey darken-2",
          title: "Closed"
        },
        disputed: {
          condition: task.last_task_status === DISPUTED,
          icon: "mdi-clipboard-alert-outline",
          color: "orange darken-2",
          title: "Disputed"
        },
        overdue: {
          condition: task.overdue,
          icon: "mdi-clipboard-text-clock-outline",
          color: "red darken-2",
          title: "Overdue"
        },
        new: {
          condition: task.last_task_status === NEW,
          // No icon for "New" status
          color: "blue darken-2",
          title: "New"
        },
        inProgress: {
          condition: task.last_task_status === IN_PROGRESS || (task.is_open && task.last_task_status === DISPUTED),
          icon: "mdi-clipboard-text-outline",
          color: "green darken-2",
          title: "In Progress"
        }
      };

      // If the task is closed, that's the only status that matters.
      if (statusMap.closed.condition) {
        return {
          icon: statusMap.closed.icon,
          color: statusMap.closed.color,
          title: statusMap.closed.title,
          statuses: [statusMap.closed.title]
        };
      }

      // Build the statuses array for all other statuses.
      let statuses = [];
      Object.keys(statusMap).forEach(key => {
        const s = statusMap[key];
        if (s.condition) {
          statuses.push(s.title);
        }
      });

      // Check for "Unread" status.
      let unread = false;
      if (task.is_open == 1) {
        // If coach hasn't read the last reply, mark as Unread.
        if (task.last_reply_read_by_coach == 0) {
          unread = true;
        } else if (task.replies && task.replies.length > 0) {
          // Order the replies by created_at ascending and check the last reply.
          const sortedReplies = task.replies.slice().sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
          const lastReply = sortedReplies[sortedReplies.length - 1];
          if (lastReply && lastReply.reply_read === 0) {
            unread = true;
          }
        }
      }
      if (unread) {
        statuses.push("Unread");
      }

      // Determine the primary status for display. Overdue takes precedence over New/In Progress.
      let primaryStatus;
      if (statusMap.overdue.condition) {
        primaryStatus = statusMap.overdue;
      } else if (statusMap.disputed.condition) {
        primaryStatus = statusMap.disputed;
      } else if (statusMap.new.condition) {
        primaryStatus = statusMap.new;
      } else if (statusMap.inProgress.condition) {
        primaryStatus = statusMap.inProgress;
      } else {
        primaryStatus = defaultTask;
      }

      return {
        icon: primaryStatus.icon || defaultTask.icon,
        color: primaryStatus.color || defaultTask.color,
        title: primaryStatus.title || defaultTask.title,
        statuses: statuses
      };
    }
  }
};
